(function () {
	'use strict';

    angular.module("imApp").factory("docArticleTopUserGroupsService", ['$ihttp', function ($ihttp) {
		let service = {
            listTopUserGroups: function (parms) {
                return $ihttp.post({
                    method: 1382,
                    parameters: parms || {}
                });
            }
		};

		return service;
	}]);
})();
